// comments
	$(function () {
		$('.b-menu-mobile').each(function () {
			var $context = $(this);
			var $menuHolders = $('.b-menu-mobile__holder', $context);
			var $menuLevels = $('.b-menu-mobile__list', $context);
			var $menuItems = $('.b-menu-mobile__item', $context);
			var $menuItemsContain = $menuItems.filter('.is-contain');
			var $menuLinks = $('.b-menu-mobile__link', $context);
			var isMobile = $context.is('.is-mobile');
			var showMore = $('.is-additional', $context);
			var $chevrons;

			if(showMore.length > 0){
           			showMore.click(function(e){
					e.preventDefault();
                			showMore.closest("ul").find(".b-menu-mobile__item.is-hide").toggle();
				});
			}

			// Инициализация блока
			(function init(){
				$context.removeClass('no-js');
				initShowMore();
				if(isMobile) {
					addRealChevrons();
				}
			})();

			function addRealChevrons(){
				$menuItemsContain.each(function(){
					$(this).append('<span class="b-menu-mobile__chevron">\n' +
						'<svg width="12" height="20" viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg">\n' +
						'<path d="M2.56065 0.939453L11.6213 10.0001L2.56065 19.0608L0.439331 16.9395L7.37867 10.0001L0.439331 3.06077L2.56065 0.939453Z"/>\n' +
						'</svg></span>');
				});
				$chevrons = $('.b-menu-mobile__chevron', $context);
				$chevrons.on('click', function(e){
					$(this).closest('.is-contain').toggleClass('is-opened').siblings('.is-contain').removeClass('is-opened');
					let $level = $(this).parents('.is-opened').length;
					$context.removeClass('is-level0 is-level1 is-level2').addClass('is-level' + $level);
					$('.b-sidebar__hidden-screen').animate({ scrollTop: 170 }, "slow");
				});
			}

			// Раскрытие списка доп.пунктов
			function initShowMore() {
				var $moreLink = $('.b-menu-mobile__link.js-show-more', $context);
				var $moreHolder = $('.b-menu-mobile__additional-holder', $context);

				$moreLink.on('click', function () {
					$moreHolder.addClass('is-opened');
					$moreLink.addClass('is-hide');
					return false;
				});
			}

		});
	});
